import { useEffect } from 'react';

import { anonymizeUser, identifyUser, initFullStory } from '@/lib/fullstory';
import { useAuthStore } from '@/stores/useAuthStore';

interface FullStoryProviderProps {
  children: React.ReactNode;
}

export const FullStoryProvider: React.FC<FullStoryProviderProps> = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    initFullStory();
  }, []);

  useEffect(() => {
    if (user !== null) {
      identifyUser(user);
    } else {
      anonymizeUser();
    }
  }, [user]);

  return <>{children}</>;
};
